enum zIndexes {
  low = 1,
  medium = 100,
  high = 1000,
  nineThousand = 9000,
  overNineThousand = 9001,
}

export default zIndexes;
